<template>
    <div>
        <page-title>{{ $t('invoices.page_title') }}</page-title>
        <users-table
            ref="table"
            :itemid="itemId"
            :itemtype="itemType"
            @company-filter="companyFilter = $event"
        >
        </users-table>
    </div>
</template>

<script>
import PageTitle from '@/components/layout/components/pageTitle'
import routeType from '@/router/routeType'
import UsersTable from '@/components/pages/invoices/Dashboard'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: {
        PageTitle,
        UsersTable,
    },
    mixins: [AuthMixin],
    data() {
        return {
            routeType,
            companyFilter: null,
            itemId: this.$route.params?.itemId || null,
            itemType: this.$route.name || null,
        }
    },
}
</script>
